import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './call-me-back.component.scss';
import * as $ from 'jquery';
var CallMeBack = /** @class */ (function (_super) {
    tslib_1.__extends(CallMeBack, _super);
    function CallMeBack(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openCallMeBackModal', _this, _this.openCallMeBackModal.bind(_this));
        return _this;
    }
    CallMeBack.prototype.init = function () {
        this.modals = Array.from(this.element.querySelectorAll('.js-call-me-back-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-call-me-back-modal-open'));
        this.closeButton = this.element.querySelector('.js-call-me-back-modal-close');
        this.openButton = this.element.querySelector('.js-call-me-back-modal-open');
        this.buttonContainer = this.element.querySelector('.call-me-back-toggle');
        this.toggleTabsButtons = Array.from(this.element.querySelectorAll('.js-toggle-tab'));
        this.tabs = Array.from(this.element.querySelectorAll('.call-me-back__tab-content'));
        this.callMeBackForm = this.element.querySelector('form');
        this.formSubmitButton = this.element.querySelector('.js-call-me-back-submit');
        this.formRadioButtons = Array.from(this.element.querySelectorAll('.js-identification_radio--group'));
        this.formSuccessMessage = this.element.querySelector('.js-call-me-back-success-message');
        this.formErrorMessage = this.element.querySelector('.js-call-me-back-error-message');
    };
    CallMeBack.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideCallMeBackModal(event);
        }); });
        window.addEventListener('scroll', function (event) { return _this.onScroll(event); });
        this.closeButton.addEventListener('click', function (event) { return _this.closeCallMeBackModal(); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openCallMeBackModals(event);
        }); });
        this.toggleTabsButtons.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleTabs(event);
        }); });
        this.formRadioButtons.map(function (item) { return item.addEventListener('click', function (event) {
            var evt = event.target;
            var identificationField = _this.callMeBackForm.querySelector('input[name=identification]');
            var identificationType = evt.value;
            if (identificationType === 'said') {
                identificationField.classList.remove('form__input--identification--passport');
                identificationField.classList.add('form__input--identification');
                identificationField.placeholder = 'Enter you South Africa ID number';
                identificationField.type = 'number';
            }
            else {
                identificationField.classList.remove('form__input--identification');
                identificationField.classList.add('form__input--identification--passport');
                identificationField.placeholder = 'Enter you Passport number';
                identificationField.type = 'text';
            }
        }); });
        if (this.formSubmitButton) {
            this.formSubmitButton.addEventListener('click', function () {
                var formFields = _this.callMeBackForm.querySelectorAll('input, select');
                _this.validationService.validate(formFields);
                var valid = Array.from(_this.callMeBackForm.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.formsService.detect(_this.callMeBackForm, _this.element.querySelector('.form__loader--container'), _this.element.querySelector('.form__thankyou--container'));
                }
                else {
                    _this.showErrorPopup();
                }
            });
        }
        this.formErrorMessage.addEventListener('click', function () { return _this.hideErrorPopup(); });
        var inputFields = this.element.querySelectorAll('input');
        for (var i = 0; i < inputFields.length; i++) {
            inputFields[i].addEventListener('input', function () { return _this.hideErrorsOnFields(); });
        }
    };
    CallMeBack.prototype.onScroll = function (event) {
        var _this = this;
        setTimeout(function () {
            var footerHeight = document.querySelector('footer').offsetHeight;
            if ((window.innerHeight + document.documentElement.scrollTop) >= (document.body.offsetHeight - footerHeight)) {
                _this.hideComponent();
            }
            else {
                _this.showComponent();
            }
        }, 200);
    };
    CallMeBack.prototype.showComponent = function () {
        this.element.classList.remove('call-me-back--hidden');
    };
    CallMeBack.prototype.hideComponent = function () {
        this.element.classList.add('call-me-back--hidden');
    };
    CallMeBack.prototype.isClickOutsideCallMeBackModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeCallMeBackModal();
        }
    };
    CallMeBack.prototype.openCallMeBackModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-call-me-back-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getCallMeBackModalById(modalId);
        this.openCallMeBackModal();
    };
    CallMeBack.prototype.closeCallMeBackModal = function () {
        var _this = this;
        this.analyticsService.dtmFormAbandon();
        this.activeModal.classList.add('modal--close');
        this.activeModal.querySelector('.call-me-back__modal-dialog').classList.remove('call-me-back__modal-dialog--open');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
        this.showOpenButton();
        setTimeout(function () {
            _this.hideSuccessMessage();
        }, 500);
    };
    CallMeBack.prototype.openCallMeBackModal = function () {
        this.resetForm();
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
        this.activeModal.querySelector('.call-me-back__modal-dialog').classList.add('call-me-back__modal-dialog--open');
        this.showCloseButton();
    };
    CallMeBack.prototype.getCallMeBackModalById = function (id) {
        return document.querySelector("#" + id);
    };
    CallMeBack.prototype.showOpenButton = function () {
        var _this = this;
        this.closeButton.classList.remove('call-me-back-toggle__toggle-icon--visible');
        setTimeout(function () {
            _this.buttonContainer.classList.add('call-me-back-toggle--closed');
        }, 150);
        setTimeout(function () {
            _this.openButton.classList.add('call-me-back-toggle__toggle-text--visible');
        }, 300);
    };
    CallMeBack.prototype.showCloseButton = function () {
        var _this = this;
        this.openButton.classList.remove('call-me-back-toggle__toggle-text--visible');
        setTimeout(function () {
            _this.buttonContainer.classList.remove('call-me-back-toggle--closed');
        }, 150);
        setTimeout(function () {
            _this.closeButton.classList.add('call-me-back-toggle__toggle-icon--visible');
        }, 300);
    };
    CallMeBack.prototype.toggleTabs = function (event) {
        this.hideTabs();
        event.currentTarget.classList.add('call-me-back__tab--active');
        var goToTab = event.currentTarget.getAttribute('data-tab');
        this.element.querySelector("#" + goToTab).classList.add('call-me-back__tab-content--active');
    };
    CallMeBack.prototype.hideTabs = function () {
        for (var i = 0; i < this.toggleTabsButtons.length; i++) {
            this.toggleTabsButtons[i].classList.remove('call-me-back__tab--active');
        }
        for (var i = 0; i < this.tabs.length; i++) {
            this.tabs[i].classList.remove('call-me-back__tab-content--active');
        }
    };
    CallMeBack.prototype.submitForm = function (event) {
        var _this = this;
        event.preventDefault();
        var validated = this.validateInput();
        if (validated) {
            var form = document.querySelector('form');
            var data = new FormData(form);
            this.showSuccessMessage();
        }
        else {
            this.showErrors();
            setTimeout(function () {
                _this.hideErrorPopup();
            }, 5000);
        }
    };
    CallMeBack.prototype.validateInput = function () {
        var inputs = document.querySelector('form').getElementsByTagName('input');
        for (var i = 0; i < inputs.length; i++) {
            if (!inputs[i].value) {
                return false;
            }
        }
        return true;
    };
    CallMeBack.prototype.showErrors = function () {
        var formGroups = document.getElementsByClassName('form__group');
        for (var i = 0; i < formGroups.length; i++) {
            var input = formGroups[i].querySelector('input');
            if (input.value === '') {
                formGroups[i].classList.add('form__group--error');
            }
        }
        this.showErrorPopup();
    };
    CallMeBack.prototype.showErrorPopup = function () {
        var _this = this;
        this.formErrorMessage.classList.add('call-me-back__error-message--visible');
        setTimeout(function () {
            _this.formErrorMessage.classList.remove('call-me-back__error-message--hidden');
        }, 250);
    };
    CallMeBack.prototype.hideErrorPopup = function () {
        var _this = this;
        this.formErrorMessage.classList.add('call-me-back__error-message--hidden');
        setTimeout(function () {
            _this.formErrorMessage.classList.remove('call-me-back__error-message--visible');
        }, 250);
    };
    CallMeBack.prototype.hideErrorsOnFields = function () {
        var formGroupsWithErrors = document.getElementsByClassName('form__group--error');
        for (var i = 0; i < formGroupsWithErrors.length; i++) {
            formGroupsWithErrors[i].classList.remove('form__group--error');
        }
        this.hideErrorPopup();
    };
    CallMeBack.prototype.showSuccessMessage = function () {
        this.hideErrorsOnFields();
        this.callMeBackForm.classList.remove('call-me-back__form--visible');
        this.formSuccessMessage.classList.add('call-me-back__message--visible');
    };
    CallMeBack.prototype.hideSuccessMessage = function () {
        this.formSuccessMessage.classList.remove('call-me-back__message--visible');
        this.callMeBackForm.classList.add('call-me-back__form--visible');
    };
    CallMeBack.prototype.resetForm = function () {
        if (this.callMeBackForm) {
            this.callMeBackForm.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    return CallMeBack;
}(Base));
export { CallMeBack };



//////////////////
// WEBPACK FOOTER
// ./components/call-me-back/call-me-back.component.ts
// module id = 171
// module chunks = 0